import * as React from "react";
import { Row, Col, Form, notification } from "antd";
import StandardButton from "src/components/common/StandardButton/StandardButton";
import { useContext, useState, useEffect } from "react";
import { FormComponentProps } from "antd/lib/form";
import PbrInvoiceUploader, { IFileToUpload } from "src/components/common/PbrInvoiceUploader/PbrInvoiceUploader";
import Title from "src/components/common/Title";
import { PbrSeparator } from "src/components/common/Separator/Separator";
import { IVendaProps } from "src/services/interfaces/IVendaProps";
import { ServiceContext } from "src/services/provider/Service.provider";
import "./invoice-upload.scss";

function InvoiceUpload(props: FormComponentProps & IVendaProps) {
  const { documentService, tradeService } = useContext(ServiceContext);
  const [loading, setLoading] = useState(false);
  const [invoice, setInvoice] = useState<any>(null);

  const [sendInvoiceSuccess, setSendInvoiceSuccess] = useState(false);
  const [fetchInvoiceSuccess, setFetchInvoiceSuccess] = useState(false);
  const [hasUploadChange, setHasUploadChange] = useState(false);

  useEffect(() => {
    fetch();
  }, []);

  async function fetch(params = {}) {
    setLoading(true);

    try {
      const document = await documentService.getInvoiceByTradeId(props.trade.id);
      if (document && document.fileName) {
        setFetchInvoiceSuccess(true);
      }
      setInvoice(document);
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Falha na consulta",
        description: "Ocorreu um erro durante a consulta. Tente novamente."
      });
    } finally {
      setLoading(false);
    }
  }

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setSendInvoiceSuccess(false);
    tradeService
      .putUploadInvoice({
        id: 0,
        category: "OFFICER_INVOICE",
        file: invoice.file,
        description: "Nota Fiscal",
        storageType: "S3",
        tradeId: props.trade.id,
        fileName: invoice.name
      })
      .then(res => {
        setSendInvoiceSuccess(true);
        notification.success({
          message: "Nota Fiscal enviada com sucesso!",
          description: "Nota Fiscal enviada com sucesso"
        });
      })
      .catch(err => {
        notification.error({
          message: "Ocorreu um erro",
          description: "Falha no envio da nota fiscal, por favor tente novamente"
        });
      })
      .finally(() => setLoading(false));
  }

  function handleChange(fileToUpload: IFileToUpload) {
    fileToUpload.type = "invoice";
    setInvoice(fileToUpload);
    setHasUploadChange(true);
  }

  return (
    <div className="documents steps-container">
      <h1>Envio de notal fiscal</h1>
      <Form onSubmit={handleSubmit}>
        {(sendInvoiceSuccess || fetchInvoiceSuccess) && (
          <React.Fragment>
            <Title size="h3" style={{ color: "#211947", margin: 0, textAlign: "center" }}>
              <br />
              A documentação foi enviada e está sob análise do nosso time jurídico.
              <br />
              Após a conclusão enviaremos um e-mail com os dados do Pagamento.
              <br />A nota fiscal pode ser reenviada abaixo.
            </Title>
            <PbrSeparator />
          </React.Fragment>
        )}

        <Row type="flex" justify="center" align="middle" className="document-row" gutter={16}>
          <Col
            xs={24}
            lg={24}
            style={{
              minHeight: "67px",
              paddingBottom: "50px"
            }}
          >
            <PbrInvoiceUploader
              btnText={`Subir Arquivo`}
              defaultValue={invoice}
              title={`Envie o arquivo da Nota Fiscal.`}
              onChangeBase64={val => handleChange(val)}
              style={{ textAlign: "center" }}
              name={"upload"}
            />
          </Col>
          {invoice && invoice.name !== undefined && (
            <Col xs={{ span: 24, offset: 17 }} lg={{ span: 24, offset: 17 }}>
              <StandardButton disabled={!(invoice && hasUploadChange)} loading={loading} htmlType="submit" style={{ textAlign: "center" }}>
                Enviar Nota Fiscal
              </StandardButton>
            </Col>
          )}
        </Row>
      </Form>
    </div>
  );
}

export default Form.create()(InvoiceUpload);



// WEBPACK FOOTER //
// ./src/pages/step-flow/steps/invoice-upload/InvoiceUpload.tsx